<template>
<!-- 卸船组件 -->
  <el-dialog :title="this.rowData.id?'编辑':'卸船'" :visible.sync="dialog" @close="closeDialog" :close-on-click-modal="false" width="600px" center>
    <el-form :inline="true" ref="XCform" enctype="multipart/form-data" :model="XCform" :rules="rules"  class="demo-form-inline jiaoyan" label-width="110px" size="mini">
       <div>
         <el-form-item label="卸船类型"  prop="shipUnloadType">
            <el-radio-group v-model="XCform.shipUnloadType" @change="shipUnloadChange">
              <el-radio :label=3>过驳</el-radio>
              <el-radio :label=1>入库</el-radio>
              <el-radio :label=2>自提</el-radio>
            </el-radio-group>
          </el-form-item>
       </div>
        <div>
          <!-- <el-form-item label="仓库名称" prop="receivingAddressNameO" v-if="XCform.shipUnloadType==1" >
            <el-select  v-model="XCform.receivingAddressNameO"  value-key="id"  placeholder="请选择" filterable>
            <el-option v-for="(item,index) in MTList" :label="item.addressName" :value="item" :key="index"></el-option>
            </el-select>
          </el-form-item> -->
          <el-form-item label="仓库名称" prop="addressName" v-if="XCform.shipUnloadType==1" >
            <el-select  v-model="XCform.addressName"  value-key="id"  placeholder="请选择" filterable>
            <el-option v-for="(item,index) in MTList" :label="item.addressName" :value="item.addressName" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="目的港口" prop="addressName" v-if="XCform.shipUnloadType==2" >
            <el-select  v-model="XCform.addressName"  value-key="id"  placeholder="请选择" filterable>
            <el-option v-for="(item,index) in JHList" :label="item.addressName" :value="item.addressName" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </div>
        <div>
          <el-form-item label="驳船名称" prop="shipUnloadRemark" v-if="XCform.shipUnloadType==3" >
            <el-input maxlength="50"  placeholder="" v-model="XCform.shipUnloadRemark"></el-input>
          </el-form-item>
        </div>
        <!-- <div>
          <el-form-item label="交货地" prop="addressName" v-if="XCform.shipUnloadType==1 || XCform.shipUnloadType==2" >
            <el-select  v-model="XCform.addressName"  value-key="id"  placeholder="请选择" filterable>
            <el-option v-for="(item,index) in JHList" :label="item.addressName" :value="item.addressName" :key="index"></el-option>
            </el-select>
          </el-form-item>
        </div> -->
        <!-- <el-form-item label="承运司机:" prop="dirverName" class="is-required">
          <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="XCform.dirverName"></el-input>
        </el-form-item>
        <el-form-item :label="XCform.shipUnloadType==2?'拉运车号:':'入库车号:'" prop="vhcNo" class="is-required">
          <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="XCform.vhcNo"></el-input>
        </el-form-item>
        <el-form-item label="联系电话:" prop="dirverMobile" class="is-required">
          <el-input   class="disabled" maxlength="20" :readonly="true"  v-model="XCform.dirverMobile"></el-input>
        </el-form-item>
        <el-form-item >
          <el-button type="primary"     @click="zhipaiFn">指派</el-button>
        </el-form-item> -->
    </el-form>
    <div v-if="flag">
        <div class="addressBox">
            <h4 class="title">
              <span><i class="fa fa-bookmark-o iconFont" aria-hidden="true"></i>指派新司机</span>
            </h4>
        </div>
         <!-- 头部查询 -->
              <el-form :inline="true" :model="SJsearchFrom" ref="SJsearchFrom" class="demo-form-inline" label-width="110px" size="mini">
                <div class=" inpBox">
                  <el-form-item label="司机姓名:" prop="name">
                    <el-input  placeholder="" v-model="SJsearchFrom.name"></el-input>
                  </el-form-item>
                  <el-form-item label="身份证号:" prop="identityNo">
                    <el-input  placeholder="" v-model="SJsearchFrom.identityNo"></el-input>
                  </el-form-item>
                      <el-form-item >
                    <el-button type="primary" @click="SJsearchFn">查询</el-button>
                  </el-form-item>
                  <el-form-item >
                    <el-button type="primary" @click="resetForm()">重置</el-button>
                  </el-form-item>
                </div>
              </el-form>
              <!-- 表格数据 -->
              <div>
                <!-- 表格 -->
                <div>
                  <el-table
                    :data="SJList"
                    ref="table"
                    v-loading="loading"
                    bordersize="mini"
                    @row-click="handleRowClick"
                    class="table"
                    height="380px"
                    style="width: 100%"
                    center
                    border
                  >
                    <!-- <el-table-column type="selection" width="30" :reserve-selection="true"></el-table-column> -->
                    <el-table-column  type="index" width="55" label="序号"></el-table-column>
                    <el-table-column label="操作" width="80">
                      <template slot-scope="scope">
                        <el-button type="text"  @click="SJZPfn(scope.row,2)" size="mini">指派</el-button>
                      </template>
                    </el-table-column>
                    <el-table-column prop="name" min-width="120" :show-overflow-tooltip="true"  label="司机姓名"></el-table-column>
                    <el-table-column prop="mobile" width="150" label="联系电话"></el-table-column>
                     <el-table-column property="identityNo" label="身份证号" width="200">
                      <template scope="scope">
                        <p v-if="scope.row.tenantId!=tenantCode">
                          {{scope.row.identityNo.replace(/^(.{4})(?:\d+)(.{4})$/, "$1**********$2")}}
                        </p>
                        <p v-else>{{scope.row.identityNo}}</p>
                      </template>
                    </el-table-column>
                  </el-table>
                </div>
                <!-- 分页 -->
                <div>
                  <el-pagination background
                    @size-change="SJhandleSizeChange"
                    @current-change="SJhandleCurrentChange"
                    :current-page="SJsearchFrom.pageNo"
                    :page-sizes="[25,50,100]"
                    :page-size="SJsearchFrom.pageSize"
                    layout="total, sizes, prev, pager, next, jumper"
                    :total="SJtotal">
                  </el-pagination>
                </div>
              </div>
               <el-dialog append-to-body title="选择车辆" :visible.sync="carMark"  :close-on-click-modal="false" width="900px" center>
        <!-- 内容 -->
        <div>
          <!-- 表格数据 -->
          <div class="tableQiye">
            <!-- 表格 -->
            <div>
              <el-table :data="carList" ref="table" v-loading="loading" bordersize="mini"
                @row-click="handleRowClick"  class="table" height="380px" style="width: 100%"   center  border   >
                <el-table-column type="index" width="55" label="序号"></el-table-column>
                <el-table-column label="操作">
                  <template slot-scope="scope">
                    <el-button type="text"  @click="carOk(scope.row)" size="mini">选择车辆</el-button>
                  </template>
                </el-table-column>
               <el-table-column prop="vhcNo"  width="100" label="车牌号"></el-table-column>
                <el-table-column prop="vhcTypeName"  width="150" :show-overflow-tooltip="true" label="车辆类型"></el-table-column>
                <el-table-column property="vehicleTenantName" width="240"  :show-overflow-tooltip="true" label="所属单位/个人" > </el-table-column>
                <el-table-column prop="energyName"  width="150" :show-overflow-tooltip="true" label="能源类型"></el-table-column>
                <el-table-column prop="drivingLicense" width="170"  :show-overflow-tooltip="true" label="行驶证号"></el-table-column>
              </el-table>
            </div>
          </div>
        </div>
         <span slot="footer" class="dialog-footer">
          <el-button @click="carMark=false">关闭</el-button>
        </span>
      </el-dialog>
    </div>
    <span slot="footer" class="dialog-footer">
      <el-button @click="dialog = false">取 消</el-button>
      <el-button type="primary" @click="HCsave('QSFrom')">确 定</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { cDlist, getCVehicleInfoAllByDriverId } from '@/api/vgs-driver2.0'
import { sAddressList, BGRshipUnload, shipUnloadSwitch } from '@/api/shipping'
export default {
  name: 'changeCar',
  props: {
    rowData: {
      type: Object,
      default: function () {
        return {}
      }
    }
  },
  data () {
    return {
      JHList: [],
      tenantCode: '',
      dialog: false,
      XCform: {},
      flag: false,
      loading: false,
      rules: {
        // shipUnloadRemark: [
        //   { required: true, message: '请输入驳船名称', trigger: 'blur' }
        // ],
        shipUnloadType: [
          { required: true, message: '请选择卸船类型', trigger: 'blur' }
        ]
        // receivingAddressNameO: [
        //   { required: true, message: '请选择仓库/地址', trigger: 'blur' }
        // ],
        // addressName: [
        //   { required: true, message: '请选择交货地', trigger: 'blur' }
        // ]
      },
      pickerOptions: {

      },
      MTList: [],
      SJsearchFrom: {
        pageNo: 1,
        pageSize: 50,
        type: 1
      },
      SJList: [],
      SJtotal: 0,
      // 选择车辆
      carMark: false,
      carList: []

    }
  },
  mounted: function () { // 在更新DOM之前 调用此钩子函数 应用：可以获取原始的DOM
    this.dialog = true
    this.tenantCode = localStorage.getItem('tenantCode')
    if (this.rowData.id) {
      this.XCform = this.rowData
      if (this.XCform.shipUnloadType == 1) {
        sAddressList({ addressType: 1 }).then(res => {
          this.MTList = res
          // this.$set(this.XCform, 'receivingAddressNameO', { addressName: this.XCform.receivingAddressName, id: this.XCform.receivingAddressId })
          this.$set(this.XCform, 'addressName', { addressName: this.XCform.addressName, addressId: this.XCform.id })
        })
        // sAddressList({ addressType: 2 }).then(res => {
        //   this.JHList = res
        //   this.$set(this.XCform, 'addressName', { addressName: this.XCform.addressName, addressId: this.XCform.id })
        // })
      } else if (this.XCform.shipUnloadType == 2) {
        sAddressList({ addressType: 2 }).then(res => {
          this.JHList = res
          this.$set(this.XCform, 'addressName', { addressName: this.XCform.addressName, addressId: this.XCform.id })
        })
      } else {
        sAddressList({ addressType: 3 }).then(res => {
          this.MTList = res
          this.$set(this.XCform, 'receivingAddressNameO', { addressName: this.XCform.receivingAddressName, id: this.XCform.receivingAddressId })
        })
      }
      console.log(this.XCform)
    }
  },
  methods: {
    // 卸船类型修改
    shipUnloadChange () {
      if (this.XCform.shipUnloadType == 1) {
        sAddressList({ addressType: 1 }).then(res => {
          this.MTList = res
        })
        // sAddressList({ addressType: 2 }).then(res => {
        //   this.JHList = res
        // })
      } else if (this.XCform.shipUnloadType == 2) {
        sAddressList({ addressType: 2 }).then(res => {
          this.JHList = res
        })
      } else {
        sAddressList({ addressType: 3 }).then(res => {
          this.MTList = res
        })
      }
      if (this.XCform.addressName) {
        this.$set(this.XCform, 'addressName', '')
      }
      if (this.XCform.shipUnloadRemark) {
        this.$set(this.XCform, 'shipUnloadRemark', '')
      }
      // this.$set(this.XCform, 'receivingAddressNameO', null)
    },
    HCsave () {
      if (this.XCform.addressName && this.XCform.shipUnloadType == 1) {
        this.XCform.addressId = this.MTList.find(item1 => item1.addressName === this.XCform.addressName).id
      }
      if (this.XCform.addressName && this.XCform.shipUnloadType == 2) {
        this.XCform.addressId = this.JHList.find(item1 => item1.addressName === this.XCform.addressName).id
      }
      // if (this.XCform.addressName) {
      //   this.XCform.addressId = this.JHList.find(item1 => item1.addressName === this.XCform.addressName).id
      // }
      this.$refs.XCform.validate((valid) => {
        if (valid) {
          this.XCform.relIds = this.rowData.relIds
          this.XCform.weight = this.rowData.weight
          this.XCform.businessId = this.rowData.businessId
          if (this.XCform.shipUnloadType == 1) {
            // if (this.XCform.receivingAddressNameO.provinceCode) {
            //   for (var key in this.XCform.receivingAddressNameO) {
            //     if (key.indexOf('update') == -1 && key.indexOf('create') == -1) {
            //       if (key == 'id') {
            //         this.XCform.receivingAddressId = this.XCform.receivingAddressNameO[key]
            //       } else {
            //         let name = 'receiving' + key.substring(0, 1).toUpperCase() + key.substring(1)
            //         this.XCform[name] = this.XCform.receivingAddressNameO[key]
            //       }
            //     }
            //   }
            // }
            // this.jiekouFn(this.XCform)

            this.jiekouFn({ relIds: this.XCform.relIds, addressType: 1, shipUnloadType: 1, businessId: this.XCform.businessId, addressName: this.XCform.addressName || '', addressId: this.XCform.addressId || '' })
          } else if (this.XCform.shipUnloadType == 2) {
            this.jiekouFn({ relIds: this.XCform.relIds, addressType: 2, shipUnloadType: 2, businessId: this.XCform.businessId, addressName: this.XCform.addressName || '', addressId: this.XCform.addressId || '' })
          } else {
            this.jiekouFn({ relIds: this.XCform.relIds, addressType: 3, shipUnloadType: 3, businessId: this.XCform.businessId, shipUnloadRemark: this.XCform.shipUnloadRemark || '' })
          }
        } else {
          return false
        }
      })
    },
    jiekouFn (data) {
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      if (this.rowData.isxiechuan) {
        BGRshipUnload(data).then(res => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          loading.close()
          this.$emit('save')
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      } else {
        shipUnloadSwitch(data).then(res => {
          this.$message({
            message: '操作成功',
            type: 'success'
          })
          loading.close()
          this.$emit('save')
        }).catch(error => {
          this.$message({
            showClose: true,
            message: error.message,
            type: 'error',
            onClose () {
              loading.close()
            }
          })
        })
      }
    },
    zhipaiFn () {
      this.flag = true
      this.SJgetList(this.SJsearchFrom)
    },

    // 司机指派
    SJZPfn (row, n) {
      let that = this
      fuzhi()
      function fuzhi () {
        that.XCform.dirverId = row.id
        that.XCform.dirverIdentityNo = row.identityNo
        that.XCform.dirverName = row.name
        that.XCform.dirverMobile = row.mobile
        const loading = that.$loading({
          lock: true,
          text: '正在处理...'
        })
        getCVehicleInfoAllByDriverId({ driverId: row.id }).then(res => {
          loading.close()
          if (res.length == 0) {
            that.$alert('该司机下暂无车辆', '系统提示')
          } else if (res.length == 1) {
            that.carOk(res[0])
          } else {
            that.carMark = true
            that.carList = res
          }
        })
      }
    },
    carOk (row) {
      this.XCform.vhcId = row.id
      this.XCform.vhcNo = row.vhcNo
      this.XCform.vhcNoColor = row.noColourCode
      this.XCform.businessLicenseNo = row.businessLicenseNo
      this.flag = false
      this.carMark = false
    },

    // 查选
    SJsearchFn () {
      this.SJgetList(this.SJsearchFrom)
    },
    // 获取列表
    SJgetList (searchFrom) {
      cDlist(searchFrom).then(res => {
        this.SJList = res.list
        this.SJtotal = res.total
      })
    },
    // 每页条数
    SJhandleSizeChange (val) {
      this.SJsearchFrom.pageSize = val
      this.SJgetList(this.SJsearchFrom)
    },
    // 当前页
    SJhandleCurrentChange (val) {
      this.SJsearchFrom.pageNo = val
      this.SJgetList(this.SJsearchFrom)
    },
    // 查选
    QYsearchFn () {
      this.QYgetList(this.QYsearchFrom)
    },

    // 点击选中
    handleRowClick (row, column, event) {
      this.$refs.table.toggleRowSelection(row)
    },
    // 重置
    resetForm (formName) {
      this.SJsearchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.QYsearchFrom = {
        pageNo: 1,
        pageSize: 50,
        sysModel: '车队业务'
      }
      this.CDZsearchFrom = {
        pageNo: 1,
        pageSize: 50,
        sysModel: '车队业务'
      }
      this.ccarFrom = {}
      this.SJsearchFrom.type = 1
    },
    closeDialog () {
      this.$emit('destroy')
      this.SJsearchFrom = {
        pageNo: 1,
        pageSize: 50
      }
      this.QYsearchFrom = {
        pageNo: 1,
        pageSize: 50,
        sysModel: '车队业务'
      }
      this.CDZsearchFrom = {
        pageNo: 1,
        pageSize: 50,
        sysModel: '车队业务'
      }
      this.ccarFrom = {}
    },
    closeDialog1 () {
      this.ccarFrom = {}
    }
  },
  destroyed () {
    this.dialog = false
  }
}
</script>

<style scoped lang='less'>
/deep/.el-date-editor{
  width: 178px;
}
.addressBox .title{
  margin-left: 0;
}
.addressBox{
  margin-top:16px;
  margin-bottom: -15px;
}
</style>
